<template>
    <v-row
        no-gutters
    >
        <v-col
            md="6"
            sm="12"
        >

            <h1 class="text-h4 mb-3">Основные настройки</h1>

            <Form
                @submit.prevent="submit"
                ref="settingForm"
                :validation-schema="schema"
            >

                <Field
                    v-model="api_key"
                    name="api_key"
                    v-slot="{ field, errors }"  
                >
                    <v-text-field
                        v-bind="field"
                        :model-value="field.value"
                        label="API ключ"
                        color="indigo-darken-3"
                        variant="underlined"
                        :error-messages="errors"
                        required
                        :disabled="loading"
                        :type="show_api_key ? 'text' : 'password'"
                    >
                        <template v-slot:append>
                            <v-btn
                                variant="text"
                                icon
                                @click="show_api_key = !show_api_key"
                                size="18"
                            >
                                <v-icon
                                    v-if="show_api_key"
                                    size="16"
                                    icon="fa fa-eye"
                                />
                                <v-icon
                                    v-else
                                    size="16"
                                    icon="fas fa-eye-slash"
                                />
                            </v-btn>
                        </template>
                    </v-text-field>
                </Field>
                <div class="d-flex justify-space-between">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="success"
                        :loading="loading"
                        @click="submit"
                    >
                        Сохранить
                    </v-btn>
                </div>
            </Form>
        </v-col>
    </v-row>
</template>
<script>
import { Form, Field } from 'vee-validate'
import ru from "yup-locale-ru"
import * as yup from 'yup'

yup.setLocale(ru)

export default {
    name: 'DefaultSettingPage',
    components: {
        Form,
        Field
    },
    data: () => ({
        api_key: null,
        show_api_key: false,
        loading: false,
    }),
    mounted () {
        this.init()
    },
    methods: {
        init() {
            this.loading = true

            this.$store.dispatch('API', {
                method: 'GET',
                url: '/setting',
            }).then(res => {

                if(res.data.status === 'success') {
                    this.setField(res.data.data)
                }

                this.loading = false

            })
        },
        setField(fields) {
            for (let key in fields) {
                switch(key) {
                    case 'api_key':
                        this.api_key = fields[key]
                        break
                }
            }
        },
        submit() {

            this.$refs.settingForm.validate().then(data => {
                if(data.valid) {

                    this.save()
                }
            })
        },
        save() {

            this.loading = true

            this.$store.dispatch('API', {
                method: 'POST',
                url: '/setting/default/save',
                data: {
                    'api_key': this.api_key
                }
            }).then(res => {
                if(res.data) {
                    if(res.data.status === 'success') {
                        this.setField(res.data.data)
                    }
                } else if(res.response && res.response.status == 422) {
                    if(res.response.data.errors) {
                        this.$refs.settingForm.setErrors(res.response.data.errors)
                    }
                }

                this.loading = false
            })
        }
    },
    computed: {
        schema() {
            return yup.object({
                api_key: yup.string().required().min(2).max(255),
            })
        }
    }
}
</script>